import { AuthorizationType, MinorServiceType } from '@shared/digila'
import { createContext, use } from 'react'

export interface ServiceSelections {
  selectedServices: MinorServiceType[]
  selectedAuthorizations: AuthorizationType[]
}
export const ServiceSelectionContext = createContext({} as ServiceSelections)

export const useServiceSelectionsContext = (): ServiceSelections => {
  return use(ServiceSelectionContext)
}
